import zonesSlice from './slice';

export const { setCollapse, setSelectedZone, toggleCollapse, setZoneMapLocationUponCreation, setFreehandShapeUponCreation } = zonesSlice.actions;
